import React, { useState } from "react";
import ProfitLossPage from "../../../../entities/DashboardPage/AccountingModule/Profit&LossStatement";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";
import { useAlert } from "../../../../context/AlertContext";


const ProfitLoss = () => {
  const [data, setData] = useState()
  const {showAlert} = useAlert()

  const getProfitLoss = async(startDate,endDate) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getProfitLoss(startDate,endDate);
      if (result?.success) { 
        setData(result?.data);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"success")
      } else {
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message,"error")
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    
    <ProfitLossPage data={data} getProfitLoss={getProfitLoss}/>
  )


}

export default ProfitLoss;
